import { atom } from 'jotai';

export const isBaseKilledAtom = atom(false);
